import { UserDetails } from "@vita-learning/types";
import { decodeHtml } from "~/shared/utils";

export const userToPostHogUser = (user: UserDetails) => ({
	Email: user.email,
	Name: decodeHtml(`${user.name.first} ${user.name.last}`),
	Plan: user.plan,
	Flags: user.flags,
	"Last Signed In": new Date().toISOString(),
});

export const decodeUser = (user: UserDetails): UserDetails => ({
	...user,
	name: {
		first: decodeHtml(user.name.first),
		last: decodeHtml(user.name.last),
	},
});
